const annapurnaCircuitItinerary = {
  slug:"annapurna-circuit",
  title: "Annapurna Circuit Trek",
  duration: "10 days",
  location: "Besisahar → Manang → Thorong La Pass → Muktinath, Nepal",
  difficulty: "Hard",
  priceRange: "$$$ (High Altitude Trek)",
  bestTime: "March–May & September–November",
  description:
    "A classic Himalayan trek circling the Annapurna massif, featuring dramatic landscapes, remote villages, and the high-altitude Thorong La Pass.",
  highlights: [
    "Thorong La Pass (5,416 m)",
    "Manang acclimatization",
    "Muktinath Temple",
    "Himalayan mountain panoramas",
    "Traditional Gurung & Tibetan villages"
  ],
  highlight360Views: [
  { label: "Thorong La Pass", place: "Thorong La Pass, Nepal" },
  { label: "Manang Village", place: "Manang, Nepal" },
  { label: "Muktinath Temple", place: "Muktinath Temple, Nepal" },
  { label: "Gangapurna Lake", place: "Gangapurna Lake, Manang" },
  { label: "Annapurna Range", place: "Annapurna Himalaya, Nepal" }
],

  image:
    "https://images.unsplash.com/photo-1544735716-6e1d6e5c3d6f",

  days: [
    {
      day: 1,
      title: "Arrival in Kathmandu",
      places: [
        "Tribhuvan International Airport",
        "Kathmandu City",
        "Thamel"
      ],
      activities: [
        "Arrival and hotel transfer",
        "Trek briefing",
        "Gear preparation and rest"
      ],
      accommodation: "Kathmandu hotel",
      meals: "Dinner included"
    },
    {
      day: 2,
      title: "Kathmandu to Besisahar",
      places: [
        "Kathmandu",
        "Besisahar"
      ],
      activities: [
        "Scenic drive to Besisahar",
        "Check into lodge",
        "Evening village walk"
      ],
      accommodation: "Besisahar lodge",
      meals: "Breakfast included"
    },
    {
      day: 3,
      title: "Besisahar to Chame",
      places: [
        "Besisahar",
        "Chame",
        "Marsyangdi River"
      ],
      activities: [
        "Begin trekking",
        "Walk along Marsyangdi River",
        "Cross suspension bridges",
        "Arrive at Chame"
      ],
      accommodation: "Tea house",
      meals: "All meals included"
    },
    {
      day: 4,
      title: "Chame to Pisang",
      places: [
        "Chame",
        "Pisang",
        "Annapurna II"
      ],
      activities: [
        "Trek through pine forests",
        "View Annapurna II",
        "Reach Pisang village"
      ],
      accommodation: "Tea house",
      meals: "All meals included"
    },
    {
      day: 5,
      title: "Pisang to Manang",
      places: [
        "Manang",
        "Upper Pisang",
        "Braga Monastery"
      ],
      activities: [
        "Scenic high-route trek",
        "Visit Braga Monastery",
        "Arrive at Manang"
      ],
      accommodation: "Tea house",
      meals: "All meals included"
    },
    {
      day: 6,
      title: "Acclimatization Day in Manang",
      places: [
        "Manang",
        "Gangapurna Lake",
        "Ice Lake"
      ],
      activities: [
        "Acclimatization hike",
        "Visit Gangapurna Lake",
        "Optional hike to Ice Lake"
      ],
      accommodation: "Tea house",
      meals: "All meals included"
    },
    {
      day: 7,
      title: "Manang to Thorong Phedi",
      places: [
        "Thorong Phedi",
        "Yak Kharka"
      ],
      activities: [
        "Gradual ascent",
        "Prepare for pass crossing",
        "Early dinner and rest"
      ],
      accommodation: "Tea house",
      meals: "All meals included"
    },
    {
      day: 8,
      title: "Thorong La Pass to Muktinath",
      places: [
        "Thorong La Pass",
        "Muktinath Temple"
      ],
      activities: [
        "Early morning pass crossing",
        "Reach Thorong La Pass (5,416 m)",
        "Descend to Muktinath"
      ],
      accommodation: "Guesthouse",
      meals: "All meals included"
    },
    {
      day: 9,
      title: "Muktinath to Pokhara",
      places: [
        "Muktinath",
        "Pokhara"
      ],
      activities: [
        "Visit Muktinath Temple",
        "Drive to Pokhara",
        "Evening lakeside walk"
      ],
      accommodation: "Pokhara hotel",
      meals: "Breakfast included"
    },
    {
      day: 10,
      title: "Departure",
      places: [
        "Pokhara",
        "Kathmandu"
      ],
      activities: [
        "Return to Kathmandu",
        "Departure"
      ],
      accommodation: "N/A",
      meals: "Breakfast included"
    }
  ],

  inclusions: [
    "Tea house accommodation",
    "Experienced trekking guide",
    "All meals during trek",
    "Permits and TIMS card",
    "Ground transportation"
  ],

  exclusions: [
    "International flights",
    "Travel insurance",
    "Personal trekking gear",
    "Tips for guides and porters"
  ],

  tips: [
    "Acclimatize properly",
    "Carry altitude medication",
    "Pack layers for cold nights",
    "Stay hydrated"
  ],

  budget: {
    flights: "$600–900",
    accommodation: "$20–40/night",
    food: "$25–40/day",
    permits: "$60–100",
    transport: "$150–250",
    total: "$1,600–2,500 per person"
  }
};

export default annapurnaCircuitItinerary;
